<template>
	<nav id="page-breadcrumbs" class="breadcrumbs" :key="currentPage.id" v-if="currentPage">
		<router-link class="icon-link slide-hover slide-hover--small slide-hover--darkLight" :to="bredcrumbsInfo.link">
			<span class="sep" v-html="arrow"></span>
			<span class="text-uppercase">{{ bredcrumbsInfo.text }}</span>
		</router-link>

		<template v-if="false">
			<router-link class="icon-link slide-hover slide-hover--small slide-hover--darkLight" to="/">
				<span class="sep" v-html="arrow"></span>
				<span>Forsiden</span>
			</router-link>

			<span class="br" v-if="~['post'].indexOf(currentPage.type) && !isArchive">
				<span class="sep" v-html="indi"></span>
				<router-link
					class="slide-hover slide-hover--small slide-hover--darkLight"
					:to="'/' + archiveDetalis.link"
				>
					{{ archiveDetalis.title }}
				</router-link>
			</span>

			<template v-if="bredcrumbs && bredcrumbs.length && status === 'loaded'">
				<span class="br" v-for="item in bredcrumbs" :key="item.id">
					<span class="sep" v-html="indi"></span>
					<WpLink
						class="slide-hover slide-hover--small slide-hover--darkLight"
						:url="item.link"
						:title="item.title"
					>
						{{ item.title }}
					</WpLink>
				</span>
			</template>

			<span class="br self" v-if="self">
				<span class="sep" v-html="indi"></span>
				<span class="self-name">{{ currentPage.title }}</span>
				<span class="sep down" v-html="indi"></span>
			</span>
		</template>
	</nav>
</template>

<script>
import WpLink from '@/components/elements/WpLink'

import { indicator, arrow } from '@/components/../icons'
import { mapGetters, mapActions } from 'vuex'

export default {
	name: 'breadcrumbs',
	props: {
		self: {
			type: Boolean,
			default: true,
		},
	},
	components: {
		WpLink,
	},
	data() {
		return {
			wpvue: window.WPVUE,
			bredcrumbs: [],
			status: 'init',
			homeId: Number(window.WPVUE.page_on_front),
			arrow: arrow('var(--dark)'),
			indi: indicator('var(--dark)'),
		}
	},
	computed: {
		bredcrumbsInfo() {
			let text = 'FORSIDEN'
			let link = '/'
			switch (this.currentPostType) {
				case 'post':
					if (!this.isArchive) {
						text = 'Aktuelt'
						link = '/' + this.wpvue.options.articles_archive.slug
					}
					break
				case 'service':
					if (!this.isArchive) {
						text = 'Tjenester'
						link = '/' + this.wpvue.options.services_archive.slug
					}
					break
				case 'marketing':
					if (!this.isArchive) {
						text = 'Marked'
						link = '/' + this.wpvue.options.markets_archive.slug
					}
					break
				case 'page':
					if (this.postParent) {
						text = '____'
						link = '#'
						if (this.bredcrumbs && this.bredcrumbs.length) {
							text = this.bredcrumbs[this.bredcrumbs.length - 1].title
							link = this.bredcrumbs[this.bredcrumbs.length - 1].link
						}
					}
					break
			}

			return { text, link }
		},
		...mapGetters(['currentPage', 'currentPageID', 'currentPostType', 'isArchive']),
		postParent() {
			return this.currentPage && this.currentPage.parent
		},
		archiveDetalis() {
			let title = 'Archive'
			let link = this.wpvue.page_for_posts_slug
			switch (this.currentPostType) {
				case 'post':
					title = 'Temaartikkel'
					break
			}
			return { title, link }
		},
	},
	methods: {
		...mapActions(['getPost']),
		getParents(parentID) {
			const VM = this
			const opt = {
				type: VM.currentPage.type,
				limit: 1,
				id: parentID,
			}
			if (VM.status === 'loaded') return
			VM.getPost(opt).then((res) => {
				const parent = res.data.posts[0] || null
				VM.bredcrumbs.push(parent)
				if (parent.parent && parent.parent !== 0 && VM.currentPageID !== parent.parent) {
					VM.getParents(parent.parent)
				}

				if (parent.parent === 0) {
					VM.bredcrumbs = [...VM.bredcrumbs.reverse()]
					VM.status = 'loaded'
				}
			})
		},
	},
	mounted() {
		if (this.postParent && this.homeId !== this.postParent) {
			this.getParents(this.postParent)
		}
	},
}
</script>

<style lang="scss">
@import '@/assets/vars.scss';
@import '@/assets/mixins.scss';
.breadcrumbs {
	font-weight: 400;
	margin-bottom: 25px;
	@include fluid-type($smallResText, $wideResText, 16px, 20px);
	@include mquery($phone) {
		margin-top: 15px;
		margin-bottom: 15px;

		> * {
			display: block;
		}
	}
	.icon-link {
	}
	.self {
		.sep.down {
			display: inline-block !important;
			margin-right: 0px;
		}
	}

	a {
		display: inline-block;
		text-decoration: none;
		color: var(--dark);
	}
	span {
		white-space: nowrap;
	}
	.sep {
		margin-right: 12px;
		@include mquery($phone) {
			display: none;
		}
		svg {
			transform: rotate(180deg);
		}
		&.down {
			svg {
				transform: rotate(90deg);
			}
		}
		svg {
			width: 17px;
			height: 12px;
		}
	}
}
</style>
